var bolitas = function (contenedor, selectorSlides) {
    if (!contenedor) {
        return;
    }
    var slides = Array.from(contenedor.querySelectorAll(selectorSlides));
    if (slides.length < 2) {
        return;
    }
    var bolitas = document.createElement('nav');
    bolitas.className = 'bolitas';
    var botones = [];
    slides.forEach(function (slide, index) {
        var boton = document.createElement('button');
        boton.className = 'bolita';
        boton.setAttribute('aria-label', "Ir al slide ".concat(index + 1));
        boton.addEventListener('click', function () {
            contenedor.scrollTo({
                left: slide.offsetLeft,
                behavior: 'smooth'
            });
        });
        boton.tabIndex = index === 0 ? 0 : -1;
        boton.ariaPressed = index === 0 ? 'true' : 'false';
        bolitas.appendChild(boton);
        botones.push(boton);
    });
    botones.forEach(function (boton, index) {
        boton.addEventListener('keydown', function (e) {
            switch (e.key) {
                case 'Enter':
                case ' ': {
                    e.preventDefault();
                    boton.click();
                    break;
                }
                case 'ArrowDown':
                case 'ArrowRight': {
                    e.preventDefault();
                    var siguiente_1 = (index + 1) % botones.length;
                    botones.forEach(function (boton, i) { return boton.tabIndex = i === siguiente_1 ? 0 : -1; });
                    botones[siguiente_1].focus();
                    break;
                }
                case 'ArrowUp':
                case 'ArrowLeft': {
                    e.preventDefault();
                    var anterior_1 = (index - 1 + botones.length) % botones.length;
                    botones.forEach(function (boton, i) { return boton.tabIndex = i === anterior_1 ? 0 : -1; });
                    botones[anterior_1].focus();
                    break;
                }
            }
        });
    });
    contenedor.parentElement.appendChild(bolitas);
    contenedor.addEventListener('scroll', function () {
        var scrollLeft = contenedor.scrollLeft;
        var contenedorWidth = contenedor.clientWidth;
        botones.forEach(function (boton, index) {
            var slide = slides[index];
            if (scrollLeft >= slide.offsetLeft - contenedorWidth / 2 && scrollLeft < slide.offsetLeft + slide.clientWidth - contenedorWidth / 2) {
                boton.ariaPressed = 'true';
            }
            else {
                boton.ariaPressed = 'false';
            }
        });
    });
};
export default bolitas;
